import type { FC } from 'react';
import { Link } from '@carbon/react';

import styles from './auth.module.scss';

// O E-MAIL DO PRIMEIRO PASSO, no segundo (entrar e criar conta em dois passos, como o login do
// Carbon): o endereço escolhido e o "Trocar", que volta ao passo do e-mail.

export const EmailEscolhido: FC<{ rotulo: string; email: string; trocar: () => void }> = ({ rotulo, email, trocar }) => (
  <p className={styles.texto}>
    {`${rotulo} `}
    <span className={styles.destaque}>{email}</span>
    {' · '}
    <Link href='#trocar' inline aria-label={`Trocar o e-mail ${email}`} onClick={(e: React.MouseEvent) => { e.preventDefault(); trocar(); }}>
      Trocar
    </Link>
  </p>
);
